import React from "react";
import { Carousel, Card, Row, Col } from "react-bootstrap";

const Testimonial = () => {
  const data = [
    {
      name: "Riya sharma",
      msg: "Amazing service and fast delivery.",
      img: "https://img.freepik.com/free-photo/smiling-romantic-asian-girl-contemplating-nature-around_1262-19410.jpg",
    },
    {
      name: "Ankit",
      msg: "Very good quality products.",
      img: "https://i.pinimg.com/736x/65/31/3a/65313a2dbb8f92185f03f9a43b156d05.jpg",
    },
    {
      name: "Shail sirvastava",
      msg: "Highly recommended ",
      img:"https://st3.depositphotos.com/1001951/33555/i/1600/depositphotos_335550204-stock-photo-portrait-of-an-indian-man.jpg",
    },
    {
      name: "Meera singh",
      msg: "Great support team!",
      img: "https://thumbs.dreamstime.com/z/young-indian-woman-23082467.jpg?ct=jpeg",
    },
    {
      name: "Ravi",
      msg: "Fresh products always.",
      img: "https://images.unsplash.com/photo-1607346256330-dee7af15f7c5?auto=format&fit=crop&fm=jpg&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8aW5kaWFuJTIwbWFufGVufDB8fDB8fHww&ixlib=rb-4.1.0&q=60&w=3000",
    },
    {
      name: "Rohita sinha",
      msg: "Best experience so far.",
      img: "https://previews.123rf.com/images/thefinalmiracle/thefinalmiracle1110/thefinalmiracle111000056/11065574-a-portrait-of-a-young-indian-man.jpg",
    },
  ];

  // 🔹 Array ko 3-3 ke group me divide karna
  const chunkSize = 3;
  const slides = [];
  for (let i = 0; i < data.length; i += chunkSize) {
    slides.push(data.slice(i, i + chunkSize));
  }

  return (
    <div className="container py-5">
      {/* Heading */}
      <div className="text-center mb-4">
        <h2 className="fw-bold">What Clients Say</h2>
        <p className="text-success fw-semibold mb-0">
          Real customer feedback
        </p>
      </div>

      <Carousel
        interval={3000}   
        controls
        indicators
        ride="carousel"
      >
        {slides.map((group, index) => (
          <Carousel.Item key={index}>
            <Row className="justify-content-center">
              {group.map((item, i) => (
                <Col md={4} key={i} className="d-flex">
                  <Card className="text-center shadow-sm border-0 p-3 w-100">
                    <Card.Body>
                      <img
                        src={item.img}
                        alt={item.name}
                        className="rounded-circle mb-3"
                        width="70"
                        height="70"
                      />
                      <h6 className="fw-semibold">{item.name}</h6>
                      <p className="text-muted small mb-0">
                        “{item.msg}”
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};

export default Testimonial;
